import {getEnvValue} from "./Environment";
import React from "react";
import {Select} from "antd";

const Option = Select.Option;


export const Config = {
    domain: getEnvValue('API_URL'),
    project_name: 'Abenviro',
    api: {
        tracks: {
            duplicate_work_order: '/tracks/duplicate-workorder/',
            bill_to: {
                list: '/tracks/bill-to/',
                post: '/tracks/bill-to/',
                get: '/tracks/bill-to/',
                put: '/tracks/bill-to/',
                patch: '/tracks/bill-to/'
            },
            generator: {
                list: '/tracks/generator/',
                post: '/tracks/generator/',
                get: '/tracks/generator/',
                patch: '/tracks/generator/'
            },
            container_type: {
                list: '/tracks/container-type/',
                post: '/tracks/container-type/',
                get: '/tracks/container-type/',
                patch: '/tracks/container-type/'
            },
            truck_type: {
                list: '/tracks/truck-type/',
                post: '/tracks/truck-type/',
                get: '/tracks/truck-type/',
                patch: '/tracks/truck-type/',
                put: '/tracks/truck-type/',
            },
            truck_job: {
                list: '/tracks/jobs/',
                get: '/tracks/jobs/',
                post: '/tracks/jobs/',
                patch: '/tracks/jobs/'
            },
            truck_ownership: {
                list: '/tracks/truck-ownership/',
                get: '/tracks/truck-ownership/',
                post: '/tracks/truck-ownership/',
                patch: '/tracks/truck-ownership/'
            },
            truck: {
                list: '/tracks/truck/',
                post: '/tracks/truck/',
                get: '/tracks/truck/',
                put: '/tracks/truck/',
                patch: '/tracks/truck/'
            },
            facility: {
                list: '/tracks/facility/',
                post: '/tracks/facility/',
                get: '/tracks/facility/',
                put: '/tracks/facility/',
                patch: '/tracks/facility/'
            },
            business_category: {
                list: '/tracks/business-category/',
                post: '/tracks/business-category/',
                get: '/tracks/business-category/',
                patch: '/tracks/business-category/'
            },
            waste_stream_code: {
                list: '/tracks/waste-stream/',
                post: '/tracks/waste-stream/',
                get: '/tracks/waste-stream/',
                patch: '/tracks/waste-stream/'
            },
            waste_stream: {
                list: '/tracks/wastestream-entity/',
                post: '/tracks/wastestream-entity/',
                get: '/tracks/wastestream-entity/',
                patch: '/tracks/wastestream-entity/',
                delete: '/tracks/wastestream-entity/'
            },
            service_type: {
                list: '/tracks/service-type/',
                post: '/tracks/service-type/',
                get: '/tracks/service-type/',
                patch: '/tracks/service-type/'
            },
            industry_type: {
                list: '/tracks/industry-type/',
                post: '/tracks/industry-type/',
                get: '/tracks/industry-type/',
                patch: '/tracks/industry-type/'
            },
            service: {
                list: '/tracks/service/',
                post: '/tracks/service/',
                get: '/tracks/service/',
                delete: '/tracks/service/',
                patch: '/tracks/service/',
            },
            quotes: {
                list: '/tracks/quotes/',
                post: '/tracks/quotes/',
                get: '/tracks/quotes/',
                put: '/tracks/quotes/',
                delete: '/tracks/quotes/',
            },
            work_order: {
                list: '/tracks/work-order/',
                post: '/tracks/work-order/',
                get: '/tracks/work-order/',
                put: '/tracks/work-order/',
                patch: '/tracks/work-order/',
                delete: '/tracks/work-order/',
                csv: '/tracks/work-order/csv',
            },
            hotsheet: {
                list: '/tracks/hotsheet/',
                post: '/tracks/hotsheet/',
                get: '/tracks/hotsheet/',
                put: '/tracks/hotsheet/',
                delete: '/tracks/hotsheet/',
                copy: '/tracks/hotsheet-copy/',
                csv: '/tracks/hotsheet/csv',
            },
            transporter: {
                list: '/tracks/transporter/',
                post: '/tracks/transporter/',
                get: '/tracks/transporter/',
                put: '/tracks/transporter/',
                delete: '/tracks/transporter/'
            },
            payment_term: {
                list: '/tracks/payment-term/',
                get: '/tracks/payment-term/',
                post: '/tracks/payment-term/',
                patch: '/tracks/payment-term/'
            },
            job_description: {
                list: '/tracks/desc-template/',
                get: '/tracks/desc-template/',
                post: '/tracks/desc-template/',
                patch: '/tracks/desc-template/'
            },
            waste_profile: {
                list: '/waste-profile/',
                get: '/waste-profile/',
                post: '/waste-profile/',
                patch: '/waste-profile/',
                delete: '/waste-profile/',
            }
        },
        pdf: {
            quotes: {
                list: '/pdf/quotes/',
                get: '/pdf/quotes/'
            },
            work_order: {
                list: '/pdf/work-order/',
                get: '/pdf/work-order/'
            },
            hotsheet: {
                list: '/pdf/hotsheet/',
                get: '/pdf/hotsheet/'
            },
            waste_profile: {
                get: '/pdf/waste-profile/'
            },
            proposal:{
                url: '/pdf/proposal/'
            }
        },
        auth: {
            login: '/auth/login/',
            profile: '/auth/profile/',
            change_password: '/auth/change-password/',
            user: {
                list: '/auth/user/',
                get: '/auth/user/',
                post: '/auth/user/',
                patch: '/auth/user/'
            }
        },
        dispatch: {
            queue: {
                list: '/dispatch/queue/',
                get: '/dispatch/queue/',
                post: '/dispatch/queue/',
                put: '/dispatch/queue/',
                patch: '/dispatch/queue/',
            },signature: {
                get: '/dispatch/signature/',
                patch: '/dispatch/signature/',
            },
            routes: {
                list: '/dispatch/routes/',
                get: '/dispatch/routes/',
                post: '/dispatch/routes/',
                patch: '/dispatch/routes/'
            },
            member_roles: {
                list: '/dispatch/roles/',
                get: '/dispatch/roles/',
                post: '/dispatch/roles/',
                delete: '/dispatch/roles/',
                patch: '/dispatch/roles/'
            },
            route_order: {
                post: '/dispatch/queue/order/',
            }
        },
        dashboard: {
            main: {
                get: '/dashboard/main/'
            }
        },
        crm: {
            proposal: {
                list: '/crm/proposal/',
                post: '/crm/proposal/',
                get: '/crm/proposal/',
                put: '/crm/proposal/',
                patch: '/crm/proposal/',
                delete: '/crm/proposal/'
            },
            contact: {
                list: '/crm/contact/',
                post: '/crm/contact/',
                get: '/crm/contact/',
                put: '/crm/contact/',
                patch: '/crm/contact/'
            },
            proposal_service: {
                url: '/crm/proposal-service/',
            },
            scope: {
                url: '/crm/job-scope/',
            },
            heavy_equipment: {
                url: '/crm/heavy-equip/',
            },
            heavy_equipment_name: {
                url: '/crm/heavy-equip-name/',
            },
            waste_stream_code: {
                url: '/crm/wastestream-code/',
            },
            labor: {
                url: '/crm/labor/',
            },
            labor_name: {
                url: '/crm/labor-name/',
            },
            disposal: {
                url: '/crm/disposal/',
            },
            equip: {
                url: '/crm/equip/',
            },
            equip_name: {
                url: '/crm/equip-name/',
            },
            material: {
                url: '/crm/material/',
            },
            material_name: {
                url: '/crm/material-name/',
            },
            rental: {
                url: '/crm/rental/',
            },
            rental_company: {
                url: '/crm/rental-company/',
            },
            sub_contractor: {
                url: '/crm/sub-contractor/',
            },
            sub_contractor_name: {
                url: '/crm/sub-contractor-name/',
            },
            additions: {
                url: '/crm/additions/',
            },
            exclusion: {
                url: '/crm/exclusion/',
            },
            notes: {
                url: '/crm/notes/',
            },
            understanding: {
                url: '/crm/understanding/',
            },
            payment_term: {
                url: '/crm/payment-term/',
            },
            settings:{
                url: '/crm/setting/'
            },
            site: {
                list: '/crm/site/',
                post: '/crm/site/',
                get: '/crm/site/',
                put: '/crm/site/',
                patch: '/crm/site/'
            },
        },
        marketing: {
            phone: {
                list: '/marketing/phone/',
                post: '/marketing/phone/',
                get: '/marketing/phone/',
                patch: '/marketing/phone/',
                delete: '/marketing/phone/',
            },
            address: {
                list: '/marketing/address/',
                post: '/marketing/address/',
                get: '/marketing/address/',
                patch: '/marketing/address/',
                delete: '/marketing/address/',
            },
            lead_level: {
                list: '/marketing/lead-level/',
                post: '/marketing/lead-level/',
                get: '/marketing/lead-level/',
                patch: '/marketing/lead-level/',
                delete: '/marketing/lead-level/',
            },
            call_log: {
                list: '/marketing/call-log/',
                post: '/marketing/call-log/',
                get: '/marketing/call-log/',
                patch: '/marketing/call-log/',
                delete: '/marketing/call-log/',
            },
            head_about_us: {
                list: '/marketing/hear-about-us/',
                post: '/marketing/hear-about-us/',
                get: '/marketing/hear-about-us/',
                patch: '/marketing/hear-about-us/',
                delete: '/marketing/hear-about-us/',
            }
        },
    },
    constant: {
        quote_type: {
            workorder: 'workorder',
            hotsheet: 'hotsheet'
        },
        unit_type: {
            BAG: 'BG',
            BOX: 'BX',
            CAN: 'CN',
            DOZEN: 'DZ',
            DRUM: 'D',
            EACH: 'EA',
            FT: "FT",
            GALLONS: 'G',
            LITERS: "L",
            LOAD: "LD",
            OUNCE: "OZ",
            PACKAGE: "PKG",
            PALLET: 'PLT',
            PIECES: "PCS",
            POUNDS: "P",
            ROLLS: "RL",
            TON: "T",
            YARD: "Y"
        },
        service_type: {
            manifest: 'manifest',
            bol: 'bol',
            hotsheet: 'hotsheet',
            service: 'service'
        },
        user_type: {
            DRIVER: 'driver',
            LABORER: 'laborer'
        }
    }
};

export const UnitDropdown = () => {
    const units = Object.entries(Config.constant.unit_type);
    return units.map((item, index) => (<Option key={index} value={item[1]}>{item[0]}</Option>))
};



// WEBPACK FOOTER //
// ./src/controller/Global.jsx